<template>
<div id="template_76">
   <div id="channel-container">
      <div id="template-container" class="default-scoreboard">
          <div id="content">

            <!-- The default scoreboard -->
            <div id="default">

            <!--Live TV feed and triggered content -->
            <div id="media-wrapper">
                  <div id="media" data-zone="zone-01">
                     <!-- If live video feed something happens here -->
                        <!-- <video id="video" autoplay loop>
                        <source src="https://www.w3schools.com/howto/rain.mp4" type="video/mp4">
                        </video> -->

                        <img :src="GALLERY_HOST + '/' + zone5.val" :style="getImageStyle(zone5)">
                  </div>
            </div>

            <div id="scoreboard-wrapper">

               <!-- Top section -->
               <div class="top score-data">

                  <div class="left">
                  <div class="logo-wrapper">
                     <div class="team-logo home" data-zone="zone-02">
                        <img :src="GALLERY_HOST + '/' + zone1.val" :style="getImageStyle(zone1)">
                     </div>
                  </div>
                  
                  <div class="name-score-wrapper">
                     <div class="team-name home uppercase" data-zone="zone-04">
                        <span>{{zone3.val}}</span>
                     </div>
                     <div class="score home"><span>1</span></div>
                     <div class="timeout-wrapper">
                        <div class="score-heading home uppercase"><span>TOL</span></div>
                        <div class="board-number home"><span>2</span></div>
                     </div>
                  </div>

                  </div>

                  <div class="center time-division-wrapper">
                     <div class="time-division">
                        <div class="board-number"><span>2</span></div>
                        <div class="score-heading uppercase"><span>Period</span></div>
                     </div>

                     <div id="game-clock">
                        <div class="time"><span>43:54</span></div>
                     </div>
                  </div>

                  <div class="right">
                  <div class="name-score-wrapper">
                     <div class="team-name visitor uppercase" data-zone="zone-05">
                        <span>{{zone4.val}}</span>
                     </div>
                     <div class="score visitor"><span>1</span></div>

                     <div class="timeout-wrapper">
                        <div class="score-heading home uppercase"><span>TOL</span></div>
                        <div class="board-number home"><span>2</span></div>
                     </div>
                  </div>

                  <div class="logo-wrapper">
                     <div class="team-logo visitor" data-zone="zone-02">
                        <img :src="GALLERY_HOST + '/' + zone2.val" :style="getImageStyle(zone2)">
                     </div>
                  </div>
                  </div>

               </div><!-- END top score-data -->
            </div><!-- END scoreboard-wrapper -->

            </div><!-- END default -->
         </div>
      </div><!-- END dialogue -->
   </div>
</div>
</template>

<script>
import BaseSolonScoreboardPreview from './../Solon/BaseSolonScoreboardPreview'

export default {
   extends: BaseSolonScoreboardPreview,

   data() {
      return {
         instanceRecid: '',
         zone1: {}, //home logo
         zone2: {}, //away logo
         zone3: {}, //home text
         zone4: {}, //away text
         zone5: {} //top background
      }
   },

   created() {
      this.zone1 = this.json.tmpl.assets[0];
      this.zone2 = this.json.tmpl.assets[1];
      this.zone5 = this.json.tmpl.assets[2];

      this.zone3 = this.json.tmpl.data.text[0];
      this.zone4 = this.json.tmpl.data.text[1];
   },

}
</script>

<style lang="scss" scoped>
// vars
$width: 100vw;
$height: 100vh;

// background colors 
$darken: rgba(0,0,0,0.05); 
$black: rgba(0,0,0,1); 
$white: rgba(1,1,1,1);
$time-division: rgba(75, 165, 218,1);
$timeouts: rgba(28, 54, 92, 1);
$player-stats: rgba(34, 24, 19, 0.85);

// fonts
$red: rgb(223, 30, 36);
$darkgray: rgb(93,93,93);
$shot-clock: rgb(136,251,2);
$score: rgb(255, 215, 0);
@mixin team-name {
  font-size: 14px;
  font-weight: 700;
  // margin-bottom: 7px;
}
@mixin mini-team-name {
  font-size: 1vw;
  font-weight: 700;
  text-transform: capitalize;
}

#template_76 {
   position: relative;
   width: 560px;
   height: 400px;
   max-width: 100%;
   max-height: 100%;
   z-index: 1;
   text-align: center;
   font-family: "Roboto", sans-serif;
   font-size: 3vw;
   line-height: normal;
   color: #fff;
   overflow: hidden;
   transform: scale(1.5);
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: initial;
}

.right {
  clear: right;
}

#template-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

#template-container {
  display: block;
  opacity: 1;
  visibility: visible;
  
  #content, #default {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  #media-wrapper, 
  #scoreboard-wrapper {
    position: absolute;
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  // Live video area 16:9 ratio; 315px on output to the display 
  #media-wrapper {
    top: 0;
    left: 0;
    height: 315px;

    #media {
      width: 100%;
      height: 100%;
      background-color: black;
      position: relative;
    }

    img, 
    video {
      max-width: none;
      position: absolute;
    }
  }
 
  // Scoreboard, height 125px across all sports; 85px on output to the display
  #scoreboard-wrapper {
    top: 315px;
    left: 0;
    height: 85px;

    > div {
      margin: 0 auto;
      padding: 0 4px;
    }
  }

  //  Top section holds the team name, score, period, possesion
    .top {
       
      &.score-data {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        flex-flow: row nowrap;
        background-color: $black;
        color: #fff;

        > div {
          flex-grow: 1;
          flex-shrink: 0;
          height: 100%;
          text-align: center;
          background-color: $black;;
        }

         .left .logo-wrapper {
            margin-right: 5px;
         }

         .right .logo-wrapper {
            margin-left: 5px;
         }

        .left, .right {
          display: flex;
          // flex-basis: 460px;
          flex-basis: 178px;

          > div  {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .logo-wrapper {
            flex-basis: 42px;
            height: 85px;
            display: flex;
            align-items: center;

            .team-logo {
               width: 63px;
               height: 63px;
               position: relative;
               overflow: hidden;
            }

            img {
              position: absolute;
               max-width: unset;
            }
          }          

          .name-score-wrapper {
            flex: 1 0 40%;
            height: 100%;
            flex-direction: column;
            // justify-content: flex-start;
            // margin-top: auto;
            // margin-bottom: auto;


            > div {
              flex-grow: 0;
              flex-shrink: 1;
              min-height: 0;
            }
          }

          .team-name {
            overflow: hidden;
            max-width: 88%;
            text-align: center;
            white-space: nowrap;
            span {
              display: block;
              @include team-name ;
              color: inherit;
            }
          }

          .score {
            //  margin-top: -15px;
            span {
              display: block;
              font-size: 42px;
              font-weight: 700;
              line-height: 1;
              color: #4ba5da;
            }
          }

          .timeout-wrapper {
             display: flex;
             align-items: baseline;
             margin-top: -8px;
            .score-heading {
              font-size: 11px;
              font-weight: 700;
              color: $score;
            }
            .board-number {
              font-size: 19px;
              font-weight: 700;
              margin-left: 5px;
            }
          }



        }
        // The center div, holds the period and game clock 
        .time-division-wrapper {
          // flex-basis: 360px;
          flex-basis: 28%;
          background-color: $time-division;
          display: flex;
          flex-direction: column;

          .time-division {
            flex-grow: 1;
            flex-shrink: 0;
            padding-top: 8px;
            line-height: 1;

            .score-heading {
              font-size: 10px;
             }
   
             .board-number {
               font-size: 16px;
               font-weight: 700;
             }
          }

          #game-clock {
            flex-grow: 1;
            flex-shrink: 0;
            padding-bottom: 8px;
            font-size: 42px;
            // font-size: 5.47vw;
            font-weight: 700;
            line-height: 1.15;
          }
        }
      }
    }
  }
</style>